import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { fetchMoldReceivingWithFilters, editMoldData } from './store/slice';
import { fetchCustomers } from '../../core/redux/customer/slice';
import { showToast } from '../../core/redux/toast/slice';
import { MoldService } from '../../service/api/mold-service';
import { actions as receivingActions } from './store/slice';
import MoldReceivingModals from './mold-receiving-modals';
import MoldReceivingContent from './mold-receiving-content';
import MoldReceivingTopHead from './mold-receiving-top-head';
import { parseMoldReceivingDeepLink } from './mold-receiving-deep-link';

const { resetFilters } = receivingActions;

const MoldReceivingView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const openedDeepLinkKeyRef = useRef(null);

  useEffect(() => {
    dispatch(fetchMoldReceivingWithFilters());
    dispatch(fetchCustomers({}));
    return () => dispatch(resetFilters());
  }, []);

  useEffect(() => {
    const deepLink = parseMoldReceivingDeepLink(location.search);
    if (!deepLink) {
      openedDeepLinkKeyRef.current = null;
      return undefined;
    }

    const key = `${deepLink.toolId || ''}:${deepLink.moldInfoId || ''}`;
    if (openedDeepLinkKeyRef.current === key) {
      return undefined;
    }

    let cancelled = false;
    (async () => {
      let toolId = deepLink.toolId;
      if (!toolId && deepLink.moldInfoId) {
        try {
          const response = await MoldService.getMoldById(deepLink.moldInfoId);
          toolId = response?.response?.toolID ?? response?.response?.ToolID ?? '';
        } catch {
          toolId = '';
        }
      }

      if (cancelled) {
        return;
      }

      if (!toolId) {
        dispatch(
          showToast({
            message: 'Could not open the mold receiving record from this notification.',
            type: 'warning',
          }),
        );
        openedDeepLinkKeyRef.current = key;
        return;
      }

      dispatch(editMoldData(toolId));
      openedDeepLinkKeyRef.current = key;
    })();

    return () => {
      cancelled = true;
    };
  }, [dispatch, location.search]);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Mold Receiving</h4>
              </div>
            </div>
            <MoldReceivingTopHead />
          </div>
          <MoldReceivingContent />
          <MoldReceivingModals />
        </div>
      </div>
    </div>
  );
};

export default MoldReceivingView;
